import { QueryClient } from "@tanstack/react-query";
import { ProviderError } from "../core/providers/types";

/**
 * Card data is cached in memory for the rest of the visit (FR-21, D10): nothing goes stale or
 * is dropped, so the same query never hits the network twice. A refresh starts empty.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        // Retrying a 404 or a rate limit straight away won't help.
        retry: (failures, error) =>
          failures < 2 &&
          !(error instanceof ProviderError && ["not-found", "rate-limit"].includes(error.kind)),
      },
    },
  });
}
